export default [
  {
    path: '/v2/admin-dashboard',
    name: 'v2_admin_dashboard',
    component: () => import('@/views/v2/modules/skeleton/admin/Dashboard.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/userss',
    name: 'v2_userss',
    component: () => import('@/views/v2/modules/skeleton/admin/Users.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
]
